import { ApiError } from "@spa/api";
import { PanelPlansEditMessages } from "appAssets/messages";
import { PanelPlansEditResolverErrorStatesEnum } from "appEntries/panel/enums";

export class PanelPlansTrait {

    static getInitialErrorMessages(errors: ApiError[]): string[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case PanelPlansEditResolverErrorStatesEnum.GetPlanFailed:
                    return PanelPlansEditMessages.GetPlanFailed.message;
                 
                default:
                    return PanelPlansEditMessages.UnknownError.message;
            }
        });
    }
}